<template>
  <v-app-bar
    app
    class="elevation-4"
    height="55"
    dense
    :style="'background: #3BE287; '"
  >
    <v-toolbar-title class="ml-0 pr-0">
      <img
        src="../assets/spacestudio-noir.png"
        height="55"
        style="vertical-align: middle"
      />
    </v-toolbar-title>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          depressed
          icon
          v-on:click="$router.push({ path: '/missions' })"
          v-on="on"
          class="ml-4"
        >
          <icon
            class="black--text"
            scale="1.5"
            name="home"
            giveMeATour-v-step="0"
          />
        </v-btn>
      </template>
      <span>Home</span>
    </v-tooltip>

    <v-menu
      transition="slide-y-transition"
      nudge-bottom="15"
      offset-y
      bottom
      min-width="600"
      max-height="600"
    >
      <template v-slot:activator="{ on }">
        <h5
          v-on="on"
          class="black--text font-weight-regular pl-4 m-0 cursor-pointer"
          giveMeATour-v-step="1"
        >
          My Missions
          <v-icon light>arrow_drop_down</v-icon>
        </h5>
      </template>
      <v-list>
        <v-container
          class="px-2 py-3"
          v-if="
            analyticalMissions.length === 0 &&
            numericalMissions.length === 0 &&
            constellations.length === 0 &&
            deploymentMissions.length === 0 &&
            defenseMissions.length === 0 &&
            asterxMissions.length === 0
          "
        >
          <p class="m-0 pr-3 grey--text lighten-1">No data available</p>
        </v-container>
        <v-container class="py-0 px-2" v-if="analyticalMissions.length !== 0">
          <p class="m-0 pr-3 grey--text lighten-1">Parametric Studies</p>
          <v-divider class="m-0"></v-divider>
        </v-container>
        <v-list-item
          class="cursor-pointer menu-line"
          v-for="mission in getSortedMissionList(analyticalMissions)"
          :key="mission.id"
          @click="goToMission(mission)"
        >
          <v-list-item-title class="body-1 pr-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ mission.name }}
                </span>
              </template>
              <span style="margin: 0; padding: 0; white-space: pre-line">{{
                getInfos(mission)
              }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="editMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="edit-button grey--text lighten-4"
                  name="pen"
                />
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="copyMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="copy-button grey--text lighten-4"
                  name="copy"
                />
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="removeIfNotUsedAsReference(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="delete-button grey--text lighten-4"
                  name="trash"
                />
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          @click="$router.push({ path: '/missions' })"
          class="cursor-pointer menu-line"
          v-if="analyticalMissions.length > displayedMissionsLimit"
        >
          <v-list-item-title class="body-1 pr-5">See more...</v-list-item-title>
        </v-list-item>
        <v-container class="py-0 px-2" v-if="numericalMissions.length !== 0">
          <p class="m-0 pr-3 grey--text lighten-1">Simulations</p>
          <v-divider class="m-0"></v-divider>
        </v-container>
        <v-list-item
          class="cursor-pointer menu-line"
          v-for="mission in getSortedMissionList(numericalMissions)"
          :key="mission.id"
          @click="goToMission(mission)"
        >
          <v-list-item-title class="body-1 pr-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ mission.name }}
                </span>
              </template>
              <span style="margin: 0; padding: 0; white-space: pre-line">{{
                getInfos(mission)
              }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="editMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="edit-button grey--text lighten-4"
                  name="pen"
                />
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="copyMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="copy-button grey--text lighten-4"
                  name="copy"
                />
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="removeIfNotUsedAsReference(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="delete-button grey--text lighten-4"
                  name="trash"
                />
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          @click="$router.push({ path: '/missions' })"
          class="cursor-pointer menu-line"
          v-if="numericalMissions.length > displayedMissionsLimit"
        >
          <v-list-item-title class="body-1 pr-5">See more...</v-list-item-title>
        </v-list-item>
        <v-container class="py-0 px-2" v-if="constellations.length !== 0">
          <p class="m-0 pr-3 grey--text lighten-1">Constellations</p>
          <v-divider class="m-0"></v-divider>
        </v-container>
        <v-list-item
          class="cursor-pointer menu-line"
          v-for="mission in getSortedMissionList(constellations)"
          :key="mission.id"
          @click="goToMission(mission)"
        >
          <v-list-item-title class="body-1 pr-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ mission.name }}
                </span>
              </template>
              <span style="margin: 0; padding: 0; white-space: pre-line">{{
                getInfos(mission)
              }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="editMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="edit-button grey--text lighten-4"
                  name="pen"
                />
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="copyMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="copy-button grey--text lighten-4"
                  name="copy"
                />
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="removeIfNotUsedAsReference(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="delete-button grey--text lighten-4"
                  name="trash"
                />
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          @click="$router.push({ path: '/missions' })"
          class="cursor-pointer menu-line"
          v-if="constellations.length > displayedMissionsLimit"
        >
          <v-list-item-title class="body-1 pr-5">See more...</v-list-item-title>
        </v-list-item>
        <v-container class="py-0 px-2" v-if="deploymentMissions.length !== 0">
          <p class="m-0 pr-3 grey--text lighten-1">Deployment Strategies</p>
          <v-divider class="m-0"></v-divider>
        </v-container>
        <v-list-item
          class="cursor-pointer menu-line"
          v-for="mission in getSortedMissionList(deploymentMissions)"
          :key="mission.id"
          @click="goToMission(mission)"
        >
          <v-list-item-title class="body-1 pr-5">{{
            mission.name
          }}</v-list-item-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="editMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="edit-button grey--text lighten-4"
                  name="pen"
                />
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="copyMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="copy-button grey--text lighten-4"
                  name="copy"
                />
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="removeIfNotUsedAsReference(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="delete-button grey--text lighten-4"
                  name="trash"
                />
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          @click="$router.push({ path: '/missions' })"
          class="cursor-pointer menu-line"
          v-if="deploymentMissions.length > displayedMissionsLimit"
        >
          <v-list-item-title class="body-1 pr-5">See more...</v-list-item-title>
        </v-list-item>

        <v-container class="py-0 px-2" v-if="defenseMissions.length !== 0">
          <p class="m-0 pr-3 grey--text lighten-1">Defense</p>
          <v-divider class="m-0"></v-divider>
        </v-container>
        <v-list-item
          class="cursor-pointer menu-line"
          v-for="mission in getSortedMissionList(defenseMissions)"
          :key="mission.id"
          @click="goToMission(mission)"
        >
          <v-list-item-title class="body-1 pr-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ mission.name }}
                </span>
              </template>
              <span style="margin: 0; padding: 0; white-space: pre-line">{{
                getInfos(mission)
              }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="editMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="edit-button grey--text lighten-4"
                  name="pen"
                />
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="copyMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="copy-button grey--text lighten-4"
                  name="copy"
                />
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="removeIfNotUsedAsReference(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="delete-button grey--text lighten-4"
                  name="trash"
                />
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          @click="$router.push({ path: '/missions' })"
          class="cursor-pointer menu-line"
          v-if="defenseMissions.length > displayedMissionsLimit"
        >
          <v-list-item-title class="body-1 pr-5">See more...</v-list-item-title>
        </v-list-item>

        <v-container class="py-0 px-2" v-if="asterxMissions.length !== 0">
          <p class="m-0 pr-3 grey--text lighten-1">AsterX</p>
          <v-divider class="m-0"></v-divider>
        </v-container>
        <v-list-item
          class="cursor-pointer menu-line"
          v-for="mission in getSortedMissionList(asterxMissions)"
          :key="mission.id"
          @click="goToMission(mission)"
        >
          <v-list-item-title class="body-1 pr-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ mission.name }}
                </span>
              </template>
              <span style="margin: 0; padding: 0; white-space: pre-line">{{
                getInfos(mission)
              }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="editMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="edit-button grey--text lighten-4"
                  name="pen"
                />
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="copyMission(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="copy-button grey--text lighten-4"
                  name="copy"
                />
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="m-0"
                @click="removeIfNotUsedAsReference(mission)"
                v-on="on"
              >
                <icon
                  scale="1"
                  class="delete-button grey--text lighten-4"
                  name="trash"
                />
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          @click="$router.push({ path: '/missions' })"
          class="cursor-pointer menu-line"
          v-if="asterxMissions.length > displayedMissionsLimit"
        >
          <v-list-item-title class="body-1 pr-5">See more...</v-list-item-title>
        </v-list-item>
        <v-container class="py-0 px-3">
          <v-col class="text-right">
            <v-btn small left class="primary caption" to="/missions"
              >See all</v-btn
            >
          </v-col>
        </v-container>
      </v-list>
    </v-menu>

    <v-btn
      small
      to="/createmission"
      giveMeATour-v-step="6"
      ref="newMissionBtn"
      id="newMissionBtn"
      color="black"
      class="white--text"
      >New Mission</v-btn
    >

    <v-spacer></v-spacer>
    <v-alert color="white" :value="newUser" class="p-2 lighten-3" outlined>
      <icon name="bullhorn" class="mr-2" /> New user? Watch the video tutorials
      in the help menu!
    </v-alert>
    <v-alert
      :color="announceType"
      :value="announceMessage != null && announceMessage !== '' ? true : false"
      class="ma-2 pa-2 lighten-3"
      outlined
    >
      <icon name="bullhorn" class="mr-2" /> {{ announceMessage }}
    </v-alert>

    <v-toolbar-items>
      <v-tooltip
        bottom
        v-if="
          giveMeATour ||
          gt_OrbitTransferParam1.isActive ||
          gt_OrbitTransferParam2.isActive ||
          gt_PerformanceAnalysis.isActive
        "
      >
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" @click="stopTheTour()" color="success">
            Stop the tour
          </v-btn>
        </template>
        <span>Stop the tour</span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="this.currentUser && this.currentUser.type === 'admin'"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon to="/Admin" v-on="on">
            <icon class="black--text" scale="1.5" name="user-secret" />
          </v-btn>
        </template>
        <span>Admin board</span>
      </v-tooltip>

      <v-menu transition="slide-y-transition" open-on-hover offset-y bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" :disabled="!currentUser">
            <icon
              class="black--text"
              scale="1.47"
              name="user-astronaut"
              giveMeATour-v-step="2"
            />
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item class="cursor-pointer">
            <v-list-item-title>{{ displayedUser }}</v-list-item-title>
          </v-list-item>
          <v-divider class="m-0 p-0"></v-divider>
          <v-list-item :disabled="demoUser" @click="archives()">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >archive</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Archives</v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="demoUser" @click="groups()">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'">group</v-icon>
            </v-list-item-action>
            <v-list-item-title>Groups</v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="demoUser" @click="processes()">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >account_tree</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Processes</v-list-item-title>
          </v-list-item>
          <v-list-item @click="userSettingsDialog = !userSettingsDialog">
            <v-list-item-action>
              <icon scale="1.2" name="cog" />
            </v-list-item-action>
            <v-list-item-title>User settings</v-list-item-title>
          </v-list-item>
          <v-list-item @click="profile()">
            <v-list-item-action>
              <icon scale="1.2" name="user-cog" />
            </v-list-item-action>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-action>
              <icon scale="1.2" name="door-open" />
            </v-list-item-action>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-tooltip bottom> Toolbox </v-tooltip>

      <v-menu transition="slide-y-transition" open-on-hover offset-y bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon @click="toolboxDialog = !toolboxDialog">
            <icon
              class="black--text"
              scale="1.3"
              name="tools"
              giveMeATour-v-step="3"
            />
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item class="cursor-pointer">
            <v-list-item-title>Toolbox</v-list-item-title>
          </v-list-item>
          <v-divider class="m-0 p-0"></v-divider>
          <v-list-item @click="openToolbox('UnitsConverter')">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >compare_arrows</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Unit conversion</v-list-item-title>
          </v-list-item>
          <v-list-item @click="openToolbox('TLEDecoder')">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >trending_up</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>TLE Decoder</v-list-item-title>
            <v-list-item-action>
              <v-img
                :src="require('../assets/images/logo-chemistry.png')"
                height="20"
                width="20"
              />
            </v-list-item-action>
          </v-list-item>
          <v-list-item @click="openToolbox('TLEDistance')">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >alt_route</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Space objects separation</v-list-item-title>
            <v-list-item-action>
              <v-img
                :src="require('../assets/images/logo-chemistry.png')"
                height="20"
                width="20"
              />
            </v-list-item-action>
          </v-list-item>
          <v-list-item @click="openToolbox('TLEDeltaV')">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >fact_check</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>TLE ΔV calculator</v-list-item-title>
            <v-list-item-action>
              <v-img
                :src="require('../assets/images/logo-chemistry.png')"
                height="20"
                width="20"
              />
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            @click="openToolbox('CustomScenarioSimulation')"
            v-if="isDefenseUser"
          >
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'">route</v-icon>
            </v-list-item-action>
            <v-list-item-title>Custom scenario simulation</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="openToolbox('PropulsionCharacterisation')"
            v-if="isDefenseUser"
          >
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >local_fire_department</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Propulsion Characterisation</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu transition="slide-y-transition" open-on-hover offset-y bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" :disabled="!currentUser">
            <icon class="black--text" scale="1.3" name="flask" />
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item class="cursor-pointer">
            <v-list-item-title>Beta Developments</v-list-item-title>
          </v-list-item>
          <v-divider class="m-0 p-0"></v-divider>

          <v-list-item
            v-for="(betaDevelopment, index) in betaDevelopmentsList"
            :key="index"
            @click="betaDevelopmentClicked(betaDevelopment.route)"
          >
            <v-list-item-action>
              <icon
                :color="$vuetify.theme.dark ? '' : 'black'"
                scale="1.3"
                :name="betaDevelopment.iconName"
              />
            </v-list-item-action>
            <v-list-item-title>{{ betaDevelopment.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu transition="slide-y-transition" open-on-hover offset-y bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" :disabled="!currentUser">
            <icon
              class="black--text"
              scale="1.5"
              name="question-circle"
              giveMeATour-v-step="4"
            />
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item class="cursor-pointer">
            <v-list-item-title>Version {{ currentVersion }}</v-list-item-title>
          </v-list-item>
          <v-divider class="m-0 p-0"></v-divider>
          <v-list-item @click="guidelinesDialog = !guidelinesDialog">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >menu_book</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>General guidelines</v-list-item-title>
          </v-list-item>
          <v-list-item @click="documentationDialog = !documentationDialog">
            <v-list-item-action>
              <icon scale="1.2" name="book" />
            </v-list-item-action>
            <v-list-item-title>Documentation</v-list-item-title>
          </v-list-item>
          <v-list-item @click="openApiDialog()">
            <v-list-item-action>
              <icon scale="1.2" name="scroll" />
            </v-list-item-action>
            <v-list-item-title>API Documentation</v-list-item-title>
          </v-list-item>
          <v-list-item @click="guidedTutorialDialog = !guidedTutorialDialog">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >lightbulb</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Guided tutorials</v-list-item-title>
          </v-list-item>
          <v-list-item @click="videoDialog = !videoDialog">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >video_library</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Video tutorials</v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="demoUser" @click="openChangelogDialog()">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'"
                >fiber_new</v-icon
              >
            </v-list-item-action>
            <v-list-item-title>Changelog</v-list-item-title>
          </v-list-item>
          <v-list-item @click="licensesDialog = !licensesDialog">
            <v-list-item-action>
              <icon scale="1.2" name="hands-helping" />
            </v-list-item-action>
            <v-list-item-title>External licenses</v-list-item-title>
          </v-list-item>
          <v-list-item @click="termsDialog = !termsDialog">
            <v-list-item-action>
              <icon scale="1.2" name="balance-scale" />
            </v-list-item-action>
            <v-list-item-title>Terms and Conditions</v-list-item-title>
          </v-list-item>
          <v-list-item @click="contactDialog = !contactDialog">
            <v-list-item-action>
              <v-icon :color="$vuetify.theme.dark ? '' : 'black'">email</v-icon>
            </v-list-item-action>
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon href="mailto:support.spacestudio@exotrail.com" v-on="on">
            <icon
              style="color: #ff5a5a; caret-color: #ff5a5a"
              scale="1.5"
              name="bug"
              giveMeATour-v-step="5"
            />
          </v-btn>
        </template>
        <span>Report bug : support.spacestudio@exotrail.com</span>
      </v-tooltip>
    </v-toolbar-items>

    <v-dialog width="100%" height="100%" v-model="videoDialog">
      <tutorialVideoPlayer
        v-if="videoDialog"
        v-on:playerClosed="videoDialog = false"
      >
      </tutorialVideoPlayer>
    </v-dialog>

    <v-dialog width="900px" v-model="guidedTutorialDialog">
      <guidedTutorialDashboard
        v-if="guidedTutorialDialog"
        v-on:guidedTutorialClosed="guidedTutorialDialog = false"
      >
      </guidedTutorialDashboard>
    </v-dialog>

    <v-dialog
      v-if="
        currentToolboxName === 'TLEDistance' ||
        currentToolboxName === 'TLEDeltaV'
      "
      width="1700"
      v-model="toolboxDialog"
    >
      <Toolbox
        v-if="toolboxDialog"
        v-on:toolboxClosed="toolboxDialog = false"
        :toolboxName="currentToolboxName"
      >
      </Toolbox>
    </v-dialog>
    <v-dialog v-else width="800" v-model="toolboxDialog">
      <Toolbox
        v-if="toolboxDialog"
        v-on:toolboxClosed="toolboxDialog = false"
        :toolboxName="currentToolboxName"
      >
      </Toolbox>
    </v-dialog>

    <v-dialog width="600" v-model="userSettingsDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline black--text">
          <span>User settings</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="userSettingsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <exo-user-settings
            :disableAdvancedSettings="demoUser"
          ></exo-user-settings>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="1200" v-model="guidelinesDialog">
      <v-card>
        <v-card-title class="headline black--text" :style="backgroundStarStyle">
          <span>General guidelines</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="guidelinesDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          <H4>Presentation</H4>
          <a
            :href="require('../assets/spacestudio Introduction.pdf')"
            target="_blank"
            >Click here</a
          >
          to access the general presentation of space<b>studio</b>™ modules.<br />
          All modules are detailed in the mission creation page.<br />
          <a @click="videoDialog = true" href="javascript:void(0);"
            >Video tutorials</a
          >
          are available to explore the capacities of space<b>studio</b>™.
          <br />
          <br />
          <v-divider></v-divider>
          <H4>Navigation</H4>
          <br />
          <H5>Mission-focused software</H5>
          The user experience in space<b>studio</b>™ is focused on the missions.
          The main window is a table listing all the missions. This main window
          can be accessed from anywhere by two links in the navigation bar: the
          Exotrail logo and the "See all" button at the end of the "My missions"
          menu.<br />
          The navigation bar provides a short list of the last updated mission
          for each module.<br />
          There are two ways to create new missions: using the button of the
          main window or using the link in the navigation bar.<br />
          When creating a new mission, the modules are listed with an overview
          of the configuration and results.
          <br />
          <br />
          <H5>Objects edition</H5>
          The missions are composed of several objects. The objects are models
          that can be shared between different missions, like spacecrafts or
          orbits.<br />
          When a mission is created or edited, a menu is displayed on the left
          to list all the required objects for this mission.<br />
          The high level objects are at the top, e.g. the spacecraft.<br />
          The low level objects are at the bottom, e.g. the propulsion
          system.<br />
          Each time an object is referenced, a drop down list is displayed to
          choose one of the already built objects.<br />
          It is possible to edit or create an object directly from this dropdown
          list.<br />
          <br />
          <v-divider></v-divider>
          <H4>Special features</H4>
          <br />
          <H5>Groups</H5>
          Groups are used to share missions between users. They can also be used
          to share use cases with the support team for investigations.<br />
          Groups are managed in a specific window that be can accessed from the
          user menu in the navigation bar.<br />
          A mission can be shared to a group by clicking on the "Share" button
          in the mission table of the main window.<br />
          <i
            >More details on the "Groups" feature are explained in the "Groups"
            window.</i
          ><br />
          <br />
          <H5>Archives</H5>
          The archiving mechanism has been designed to keep your workspace clean
          and tidy. Any mission can be archived from the mission board in the
          main window. Once a mission is archived, it is no longer displayed
          inside the mission board. It can be retrieved later in the "Archive"
          window, accessible from the user menu in the navigation bar.
          <br />
          <i
            >More details on the archiving feature are explained in the
            "Archives" window.</i
          >
          <br />
          <br />
          <H5>Import</H5>
          All modules use spacecrafts, thrusters and orbits. <br />
          The models behind are different (e.g. basic circular orbits in the
          parametrics studies instead of complete orbit definitions in the
          simulations).<br />
          It is possible to convert objects from one module to the other by
          using the "IMPORT" button, next to the "NEW ..." button of each object
          table.<br />
          <br />
          <H5>Custom scripts in the parametric studies</H5>
          Create customized results by post-processing mission results.<br />
          The script is executed for each value of the parameters, it is
          executed once all the other fields are evaluated.<br />
          It can not change the results computed by space<b>studio</b>™.<br />
          The post-processing is evaluated on each result independently, there
          is no mean to compute global fields. <br />
          E.g. evaluating an average or a maximum of one field is not
          possible.<br />
          The customized result fields will be then accessible like the other
          result fields :
          <ul>
            <li>
              to make a plot : they will be displayed in the data tree under
              <i>Script Inputs</i> and <i>Script outputs</i>
            </li>
            <li>
              to export : they will be displayed in the data tree under
              <i>Script Inputs</i> and <i>Script outputs</i>
            </li>
          </ul>
          <i
            >More details on the "Custom script" feature are explained in the
            missions of the parametric studies.</i
          ><br />
          <br />
          <H5>Advanced configuration</H5>
          To keep the user interface easy to use, some features are hidden by
          default. They can be activated by using the user settings menu.<br />
          E.g. the custom scripts of parametric studies and the custom
          manoeuvring strategies of the simulations module are hidden by
          default.
          <br />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="800" v-model="documentationDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline black--text">
          <span>Documentation</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="documentationDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <H4>Physical constants</H4>
          <v-data-table
            dense
            hide-headers
            hide-default-footer
            disable-pagination
            :items="Object.keys(physicalConstants)"
          >
            <template slot="item" slot-scope="row">
              <tr class="pa-0">
                <td class="px-1 text-right">
                  <div class="text-left">
                    <b>{{ row.item }}</b>
                  </div>
                </td>
                <td class="px-1 text-right">
                  <div class="text-left">
                    {{ physicalConstants[row.item] }}
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <br /><br />
          <v-divider></v-divider>
          <H4>Fields bounds</H4>
          Most of the fields do not accept any value in forms. An error message
          will be displayed when the inputs do not respect the requirements.
          Below is a summary of all limits on fields grouped by forms. Note that
          only the fields with bounds are listed.<br />
          <br />
          <i><b>Notation: </b></i><br />
          <i><b>; </b></i><br />
          &emsp;separator between lower and upper bounds<br />
          <i><b>] </b></i><br />
          &emsp;lower bound excluded / upper bound included<br />
          <i><b>[ </b></i><br />
          &emsp;lower bound included / upper bound excluded<br />
          <i><b>+∞[ </b></i><br />
          &emsp;no maximum value<br />
          <i><b>]-∞ </b></i><br />
          &emsp;no minimum value<br />
          <i><b>]0; +∞[</b></i
          ><br />
          &emsp;any positive value bigger than 0
          <br />
          <br />
          <v-data-table
            dense
            hide-headers
            hide-default-footer
            disable-pagination
            :items="allBoundedFields"
          >
            <template slot="item" slot-scope="row">
              <tr class="pa-0">
                <td
                  class="px-1 text-right"
                  v-for="header in boundedFieldsHeaders"
                  :key="header.value"
                  :style="getFieldsBoundsStyle(row.item.range)"
                >
                  <div class="text-left">
                    {{ row.item[header.value] }}
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="800" v-model="apiDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline black--text">
          <span>API Documentation</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="apiDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <br />
          <H2>Presentation and download</H2>
          <br />
          space<b>studio</b> can be used thanks to an API to write scripts and
          to integrate with third party solutions.<br />
          A python library makes it easy to use. You will need to download and
          install it. The user manual is in <i>README.md</i>. <br />

          <a @click="downloadApiDoc()" href="javascript:void(0);">
            Download the python library and examples.</a
          >.
          <br />
          <br />
          <v-divider></v-divider>
          <br />
          <H2>Readme (from the archive)</H2>
          <br />
          <div v-html="readmeAPItranslated"></div>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="600" v-model="contactDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline black--text">
          <span>Contact</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="contactDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          Account upgrade, commercial contact:
          <a href="mailto:spacestudio@exotrail.com">spacestudio@exotrail.com</a
          ><br />
          Support, bug report, feedback, thanks:
          <a href="mailto:support.spacestudio@exotrail.com"
            >support.spacestudio@exotrail.com</a
          ><br />
          More about Exotrail:
          <a href="https://exotrail.com/" target="_blank"
            >https://exotrail.com</a
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="80%" v-model="termsDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline black--text">
          <span>Terms and Conditions</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="termsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pl-5 pd-5 mt-4">
          <span v-html="termsAndConditionsDemoContent.content"></span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="600" v-model="licensesDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline black--text">
          <span>External Licenses</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="licensesDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          space<b>studio</b>™ uses the following open-source libraries:<br />
          <br />
          <h5>Orekit</h5>
          Website:
          <a href="https://www.orekit.org/" target="_blank"
            >https://www.orekit.org</a
          ><br />
          License:
          <a href="https://www.orekit.org/license.html" target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Spring framework</h5>
          Website:
          <a href="https://spring.io/projects/" target="_blank"
            >https://spring.io/projects</a
          ><br />
          License:
          <a
            href="https://github.com/spring-projects/spring-framework/blob/master/LICENSE.txt"
            target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Nashorn Sandbox</h5>
          Website:
          <a
            href="https://github.com/javadelight/delight-nashorn-sandbox"
            target="_blank"
            >https://github.com/javadelight/delight-nashorn-sandbox</a
          ><br />
          License:
          <a
            href="https://github.com/javadelight/delight-nashorn-sandbox/blob/master/LICENSE.TXT"
            target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>JSON.simple</h5>
          Website:
          <a
            href="https://code.google.com/archive/p/json-simple/"
            target="_blank"
            >https://code.google.com/archive/p/json-simple/</a
          ><br />
          License:
          <a
            href="https://github.com/fangyidong/json-simple/blob/master/LICENSE.txt"
            target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Gson</h5>
          Website:
          <a href="https://github.com/google/gson" target="_blank"
            >https://github.com/google/gson</a
          ><br />
          License:
          <a
            href="https://github.com/google/gson/blob/master/LICENSE"
            target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Java JWT</h5>
          Website:
          <a href="https://github.com/auth0/java-jwt" target="_blank"
            >https://github.com/auth0/java-jwt</a
          ><br />
          License:
          <a
            href="https://github.com/auth0/java-jwt/blob/master/LICENSE"
            target="_blank"
            >MIT license</a
          ><br />
          <br />
          <h5>Apache Commons</h5>
          Website:
          <a href="http://commons.apache.org/" target="_blank"
            >http://commons.apache.org</a
          ><br />
          License:
          <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Apache Log4j</h5>
          Website:
          <a href="https://logging.apache.org/log4j/2.x/" target="_blank"
            >https://logging.apache.org/log4j/2.x/</a
          ><br />
          License:
          <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Apache Maven</h5>
          Website:
          <a href="https://maven.apache.org/" target="_blank"
            >https://maven.apache.org</a
          ><br />
          License:
          <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Apache Maven Resources Plugin</h5>
          Website:
          <a
            href="http://maven.apache.org/plugins/maven-resources-plugin"
            target="_blank"
            >http://maven.apache.org/plugins/maven-resources-plugin</a
          ><br />
          License:
          <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>Jackson JSON Schema Module</h5>
          Website:
          <a
            href="https://github.com/FasterXML/jackson-module-jsonSchema"
            target="_blank"
            >https://github.com/FasterXML/jackson-module-jsonSchema</a
          ><br />
          License:
          <a
            href="https://github.com/FasterXML/jackson-module-jsonSchema/wiki"
            target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <!-- no need to display org.reflections.reflections : https://github.com/ronmamo/reflections/blob/master/README.md => http://www.wtfpl.net/ -->
          <h5>Copy Rename Maven Plugin</h5>
          Website:
          <a
            href="http://coderplus.github.io/copy-rename-maven-plugin/"
            target="_blank"
            >http://coderplus.github.io/copy-rename-maven-plugin</a
          ><br />
          License:
          <a
            href="http://coderplus.github.io/copy-rename-maven-plugin/license.html"
            target="_blank"
            >MIT license</a
          ><br />
          <br />

          <h5>JOptimizer</h5>
          License:
          <a
            href="https://creativecommons.org/licenses/by-nd/4.0/legalcode"
            target="_blank"
            >Creative Commons 4.0 licence</a
          ><br />
          <br />

          <h5>Babel</h5>
          Website:
          <a href="https://github.com/babel/babel" target="_blank"
            >https://github.com/babel/babel</a
          ><br />
          License:
          <a
            href="https://github.com/babel/babel/blob/master/LICENSE"
            target="_blank"
            >MIT license</a
          ><br />
          <br />
          <h5>VueTreeselect</h5>
          Website:
          <a href="https://vue-treeselect.js.org/" target="_blank"
            >https://vue-treeselect.js.org</a
          ><br />
          License:
          <a
            href="https://github.com/riophae/vue-treeselect/blob/master/LICENSE"
            target="_blank"
            >MIT license</a
          ><br />
          <br />
          <h5>axios</h5>
          Website:
          <a href="https://github.com/axios/axios" target="_blank"
            >https://github.com/axios/axios</a
          ><br />
          License:
          <a
            href="https://github.com/axios/axios/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>flat</h5>
          Website:
          <a href="https://github.com/hughsk/flat" target="_blank"
            >https://github.com/hughsk/flat</a
          ><br />
          License:
          <a
            href="https://github.com/hughsk/flat/blob/master/LICENSE"
            target="_blank"
            >BSD 3-Clause "New" or "Revised" License</a
          ><br />
          <br />
          <h5>jwt-decode</h5>
          Website:
          <a href="https://github.com/auth0/jwt-decode" target="_blank"
            >https://github.com/auth0/jwt-decode</a
          ><br />
          License:
          <a
            href="https://github.com/auth0/jwt-decode/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>KaTeX</h5>
          Website:
          <a href="https://katex.org/" target="_blank">https://katex.org/</a
          ><br />
          License:
          <a
            href="https://github.com/KaTeX/KaTeX/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>material-design-icons-iconfont</h5>
          Website:
          <a
            href="https://jossef.github.io/material-design-icons-iconfont/"
            target="_blank"
            >https://jossef.github.io/material-design-icons-iconfont/</a
          ><br />
          License:
          <a
            href="https://github.com/jossef/material-design-icons-iconfont/blob/master/LICENSE"
            target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>vue-katex</h5>
          Website:
          <a href="https://github.com/lucpotage/vue-katex" target="_blank"
            >https://github.com/lucpotage/vue-katex</a
          ><br />
          License:
          <a
            href="https://github.com/lucpotage/vue-katex/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Vue.js notifications</h5>
          Website:
          <a href="https://github.com/euvl/vue-notification" target="_blank"
            >https://github.com/euvl/vue-notification</a
          ><br />
          License:
          <a
            href="https://github.com/euvl/vue-notification/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Vue Prism Editor</h5>
          Website:
          <a href="https://github.com/koca/vue-prism-editor" target="_blank"
            >https://github.com/koca/vue-prism-editor</a
          ><br />
          License:
          <a
            href="https://github.com/koca/vue-prism-editor/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>vue-router</h5>
          Website:
          <a href="https://github.com/vuejs/vue-router" target="_blank"
            >https://github.com/vuejs/vue-router</a
          ><br />
          License:
          <a
            href="https://github.com/vuejs/vue-router/blob/dev/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>particles.js</h5>
          Website:
          <a
            href="https://github.com/VincentGarreau/particles.js"
            target="_blank"
            >https://github.com/VincentGarreau/particles.js</a
          ><br />
          License:
          <a
            href="https://github.com/VincentGarreau/particles.js/blob/master/LICENSE.md"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>plotly.js</h5>
          Website:
          <a href="https://github.com/plotly/plotly.js" target="_blank"
            >https://github.com/plotly/plotly.js</a
          ><br />
          License:
          <a
            href="https://github.com/plotly/plotly.js/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Vue-Awesome</h5>
          Website:
          <a href="https://github.com/Justineo/vue-awesome" target="_blank"
            >https://github.com/Justineo/vue-awesome</a
          ><br />
          License:
          <a
            href="https://github.com/Justineo/vue-awesome/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Vue.js</h5>
          Website:
          <a href="https://vuejs.org/" target="_blank">https://vuejs.org</a
          ><br />
          License:
          <a
            href="https://github.com/vuejs/vue/blob/dev/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>stylus-loader</h5>
          Website:
          <a href="https://github.com/shama/stylus-loader" target="_blank"
            >https://github.com/shama/stylus-loader</a
          ><br />
          License:
          <a
            href="https://github.com/shama/stylus-loader/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Stylus</h5>
          Website:
          <a href="https://github.com/stylus/stylus" target="_blank"
            >https://github.com/stylus/stylus</a
          ><br />
          License:
          <a
            href="https://github.com/stylus/stylus/blob/dev/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>sass-loader</h5>
          Website:
          <a
            href="https://github.com/webpack-contrib/sass-loader"
            target="_blank"
            >https://github.com/webpack-contrib/sass-loader</a
          ><br />
          License:
          <a
            href="https://github.com/webpack-contrib/sass-loader/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Prism</h5>
          Website:
          <a href="https://github.com/PrismJS/prism" target="_blank"
            >https://github.com/PrismJS/prism</a
          ><br />
          License:
          <a
            href="https://github.com/PrismJS/prism/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Papa Parse</h5>
          Website:
          <a href="https://www.papaparse.com/" target="_blank"
            >https://www.papaparse.com/</a
          ><br />
          License:
          <a
            href="https://github.com/mholt/PapaParse/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>node-sass</h5>
          Website:
          <a href="https://github.com/sass/node-sass" target="_blank"
            >https://github.com/sass/node-sass</a
          ><br />
          License:
          <a
            href="https://github.com/sass/node-sass/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>vue-grid-layout</h5>
          Website:
          <a
            href="https://github.com/jbaysolutions/vue-grid-layout"
            target="_blank"
            >https://github.com/jbaysolutions/vue-grid-layout</a
          ><br />
          License:
          <a
            href="https://github.com/jbaysolutions/vue-grid-layout/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>vue-clipboard2</h5>
          Website:
          <a href="https://github.com/Inndy/vue-clipboard2" target="_blank"
            >https://github.com/Inndy/vue-clipboard2</a
          ><br />
          License:
          <a
            href="https://github.com/Inndy/vue-clipboard2/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>vue-axios</h5>
          Website:
          <a href="https://github.com/imcvampire/vue-axios" target="_blank"
            >https://github.com/imcvampire/vue-axios</a
          ><br />
          License:
          <a
            href="https://github.com/imcvampire/vue-axios/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Vuex</h5>
          Website:
          <a href="https://github.com/vuejs/vuex" target="_blank"
            >https://github.com/vuejs/vuex</a
          ><br />
          License:
          <a
            href="https://github.com/vuejs/vuex/blob/dev/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>vuetify-datetime-picker</h5>
          Website:
          <a
            href="https://github.com/darrenfang/vuetify-datetime-picker"
            target="_blank"
            >https://github.com/darrenfang/vuetify-datetime-picker</a
          ><br />
          License:
          <a
            href="https://github.com/darrenfang/vuetify-datetime-picker/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>vue-async-computed</h5>
          Website:
          <a
            href="https://github.com/foxbenjaminfox/vue-async-computed"
            target="_blank"
            >https://github.com/foxbenjaminfox/vue-async-computed</a
          ><br />
          License:
          <a
            href="https://github.com/foxbenjaminfox/vue-async-computed/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>Vuetify</h5>
          Website:
          <a href="https://vuetifyjs.com" target="_blank"
            >https://vuetifyjs.com</a
          ><br />
          License:
          <a
            href="https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>CesiumJS</h5>
          Website:
          <a href="https://cesium.com/cesiumjs/" target="_blank"
            >https://cesium.com/cesiumjs</a
          ><br />
          License:
          <a
            href="https://github.com/AnalyticalGraphicsInc/cesium/blob/master/LICENSE.md"
            target="_blank"
            >Apache 2.0 License</a
          ><br />
          <br />
          <h5>three.js</h5>
          Website:
          <a href="https://threejs.org" target="_blank">https://threejs.org</a
          ><br />
          License:
          <a
            href="https://github.com/mrdoob/three.js/blob/dev/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>D3.js</h5>
          Website:
          <a href="https://d3js.org" target="_blank">https://d3js.org</a><br />
          License:
          <a href="https://github.com/d3/d3/blob/master/LICENSE" target="_blank"
            >BSD 3-Clause "New" or "Revised" License</a
          ><br />
          <br />
          <h5>Leaflet</h5>
          Website:
          <a href="https://leafletjs.com" target="_blank"
            >https://leafletjs.com</a
          ><br />
          License:
          <a
            href="hhttps://github.com/Leaflet/Leaflet/blob/master/LICENSE"
            target="_blank"
            >BSD 2-Clause "Simplified" License</a
          ><br />
          <br />
          <h5>Mapbox GL JS</h5>
          Website:
          <a href="https://docs.mapbox.com/mapbox-gl-js/api" target="_blank"
            >https://docs.mapbox.com/mapbox-gl-js/api</a
          ><br />
          License:
          <a
            href="https://github.com/mapbox/mapbox-gl-js/blob/main/LICENSE.txt"
            target="_blank"
            >License</a
          ><br />
          <br />
          <h5>vue-cookies</h5>
          Website:
          <a href="https://github.com/cmp-cc/vue-cookies" target="_blank"
            >https://github.com/cmp-cc/vue-cookies</a
          ><br />
          License:
          <a
            href="https://github.com/cmp-cc/vue-cookies/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
          <h5>lodash</h5>
          Website:
          <a href="https://github.com/lodash/lodash" target="_blank"
            >https://github.com/lodash/lodash</a
          ><br />
          License:
          <a
            href="https://github.com/lodash/lodash/blob/master/LICENSE"
            target="_blank"
            >MIT License</a
          ><br />
          <br />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog width="800" v-model="changelogDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline black--text">
          <span>Version {{ currentVersion }}</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" @click="changelogDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          <div v-html="changelogTranslated"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-tour
      name="myTour"
      :steps="steps"
      :callbacks="myCustomCallbacks"
    ></v-tour>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import logHandler from '../mixins/logHandler'
import dataTools from '../tools/data.js'
import missionTools from '../store/mission.js'
import Toolbox from '../components/Toolbox/Toolbox.vue'
import exoUserSettings from '../components/UserSettings.vue'
import tutorialVideoPlayer from '../components/Videos/TutorialVideoPlayer.vue'
import guidedTutorialDashboard from '../components/GuidedTutorials/GuidedTutorialDashboard.vue'
import betaDevelopmentDashboard from '../components/BetaDevelopments/BetaDevelopmentDashboard.vue'
import fieldsDescription from '../tools/fieldsDescription.json'
import navigationComponents from '../components/navigationComponents.js'
import guidedTutorialParamOrbitalTransfer1 from '../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer1.js'
import guidedTutorialParamOrbitalTransfer2 from '../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer2.js'
import guidedTutorialPerformanceAnalysis from '../components/GuidedTutorials/guidedTutorialPerformanceAnalysis'
import Vue from 'vue'
import { marked } from 'marked'

export default {
  name: 'top-navbar',

  mixins: [logHandler],

  components: {
    Toolbox,
    tutorialVideoPlayer,
    guidedTutorialDashboard,
    betaDevelopmentDashboard,
    exoUserSettings
  },

  mounted: function () {
    this.$root.$on('request-logout', this.requestLogoutHandler)
    if (this.giveMeATour) {
      this.$tours['myTour'].start()
    }

    this.updateAnnounceMessage()
    this.updatePhysicalConstants()
  },

  beforeDestroy() {
    this.$root.$off('request-logout', this.requestLogoutHandler)
  },

  data() {
    const self = this
    return {
      physicalConstants: {},
      displayedMissionsLimit: 6,
      changelogDialog: false,
      videoDialog: false,
      guidedTutorialDialog: false,
      betaDevelopmentDialog: false,
      toolboxDialog: false,
      currentToolboxName: 'UnitsConverter',
      documentationDialog: false,
      apiDialog: false,
      guidelinesDialog: false,
      userSettingsDialog: false,
      contactDialog: false,
      termsDialog: false,
      licensesDialog: false,
      announceMessage: '',
      announceType: 'info',
      readmeAPIraw: '',
      changelogRaw: '',
      steps: [
        {
          target: '[giveMeATour-v-step="0"]',
          content: 'Click here to go to the <strong>home page</strong>.'
        },
        {
          target: '[giveMeATour-v-step="1"]',
          content: 'Find all your <strong>missions</strong> here.'
        },
        {
          target: '[giveMeATour-v-step="2"]',
          content:
            'This button allows you to configure your <strong>user settings</strong> (options, dark mode, etc.).'
        },
        {
          target: '[giveMeATour-v-step="3"]',
          content: 'A handy <strong>toolbox</strong> for unit conversion.'
        },
        {
          target: '[giveMeATour-v-step="4"]',
          content:
            'Here you can find a detailled <strong>documentation</strong> of the software and you can also watch some <strong>videos</strong> to get started.'
        },
        {
          target: '[giveMeATour-v-step="5"]',
          content:
            'Have you encountered a bug ? <strong>Contact the support team</strong> by clicking here.'
        },
        {
          target: '[giveMeATour-v-step="6"]',
          content:
            'You can <strong>create a new mission</strong> by clicking on this button.'
        }
      ],
      myCustomCallbacks: {
        onFinish: () => {
          self.$refs.newMissionBtn.$el.click()
        },
        onSkip: () => {
          self.$refs.newMissionBtn.$el.click()
        }
      },
      betaDevelopmentsList: [
        {
          name: 'Earth-Moon Trajectories',
          iconName: 'moon',
          route: '/earthmoontrajectoryrequest'
        },
        {
          name: 'Formation Flying',
          iconName: 'bars',
          route: '/formationflyingsimulationrequest'
        },
        {
          name: 'Inspection mission',
          iconName: 'bullseye',
          route: '/inspectionsimulationrequest'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      missions: 'missions',
      currentMission: 'currentMission',
      giveMeATour: 'giveMeATour',
      gt_OrbitTransferParam1: 'gt_OrbitTransferParam1',
      gt_OrbitTransferParam2: 'gt_OrbitTransferParam2',
      gt_PerformanceAnalysis: 'gt_PerformanceAnalysis'
    }),

    readmeAPItranslated() {
      return marked(this.readmeAPIraw)
    },

    changelogTranslated() {
      return marked(this.changelogRaw)
    },

    newUser() {
      if (this.currentUser && this.currentUser.activationdate != null) {
        const now = new Date()
        const activationDate = new Date(this.currentUser.activationdate)
        const durationDays = Math.floor(
          (now - activationDate) / (1000 * 60 * 60 * 24)
        )
        return durationDays < 30
      }
      return false
    },

    termsAndConditionsDemoContent() {
      return navigationComponents.readFormattedTermsAndCondition(
        this.currentUser
      )
    },

    backgroundStarStyle() {
      return navigationComponents.backgroundStarStyle()
    },

    currentVersion() {
      // TODO should us the changelog file of the main project
      return '3.8.3' //! current_version (DO NOT delete this comment)
    },

    demoUser() {
      return this.currentUser == null || this.currentUser.type === 'demo'
    },

    limitedUser() {
      return (
        this.currentUser != null &&
        (this.currentUser.type === 'trial' ||
          this.currentUser.type === 'educational')
      )
    },

    fullUser() {
      return (
        this.currentUser != null &&
        (this.currentUser.type === 'user' || this.currentUser.type === 'admin')
      )
    },

    numericalMissions() {
      return this.missions.filter(
        (mission) => mission.typeName === 'SimulationRequest'
      )
    },

    analyticalMissions() {
      return this.missions.filter(
        (mission) => mission.typeName === 'ParametricStudyRequest'
      )
    },

    constellations() {
      return this.missions.filter((mission) =>
        mission.typeName.toLowerCase().includes('constellation')
      )
    },

    deploymentMissions() {
      return this.missions.filter(
        (mission) => mission.typeName === 'DeploymentRequest'
      )
    },

    defenseMissions() {
      return this.missions.filter(
        (mission) =>
          mission.typeName === 'ManeuverRestitutionRequest' ||
          mission.typeName === 'ManeuverCatalogueAnalysisRequest' ||
          mission.typeName === 'DataGeneratorRequest' ||
          mission.typeName === 'ScreeningCatalogueAnalysisRequest'
      )
    },

    asterxMissions() {
      return this.missions.filter(
        (mission) => mission.typeName === 'EvasiveManeuverRequest'
      )
    },

    displayedUser() {
      if (this.currentUser !== null) {
        return 'Logged as ' + this.currentUser.email
      }
      return 'Not logged'
    },

    allBoundedFields() {
      let items = []
      for (let type of Object.keys(fieldsDescription)) {
        const typeDef = fieldsDescription[type]
        let current = { name: typeDef.label, unit: 'Unit', range: 'Range' }
        let properties = []

        if (typeDef.properties == null) {
          console.warn(
            'Missing properties in fieds description file for ' + type
          )
        }
        for (let propertyKey of Object.keys(typeDef.properties)) {
          const property = typeDef.properties[propertyKey]
          let minBound = ']-∞'
          let maxBound = '+∞['
          let boundSet = false
          const guiUnit = dataTools.getDefaultGuiUnit(property.type)
          if (property['minInclusive'] != null) {
            minBound =
              '[' +
              dataTools.convertSi2Display(
                property.type,
                dataTools.convertPiToNumber(property['minInclusive'])
              )
            boundSet = true
          }
          if (property['minExclusive'] != null) {
            minBound =
              ']' +
              dataTools.convertSi2Display(
                property.type,
                dataTools.convertPiToNumber(property['minExclusive'])
              )
            boundSet = true
          }
          if (property['maxInclusive'] != null) {
            maxBound =
              dataTools.convertSi2Display(
                property.type,
                dataTools.convertPiToNumber(property['maxInclusive'])
              ) + ']'
            boundSet = true
          }
          if (property['maxExclusive'] != null) {
            maxBound =
              dataTools.convertSi2Display(
                property.type,
                dataTools.convertPiToNumber(property['maxExclusive'])
              ) + '['
            boundSet = true
          }
          if (boundSet) {
            properties.push({
              name: property.label,
              unit: guiUnit,
              range: minBound + '; ' + maxBound
            })
          }
        }
        if (properties.length > 0) {
          items.push(current)
          items = items.concat(properties)
        }
      }
      return items
    },

    boundedFieldsHeaders() {
      let headers = []
      headers.push({ text: 'Name', value: 'name', sortable: false })
      headers.push({ text: 'Unit', value: 'unit', sortable: false })
      headers.push({ text: 'Range', value: 'range', sortable: false })
      return headers
    },

    isDefenseUser() {
      const userOptions = this.currentUser?.options
      return userOptions != null && userOptions.includes('DEFENSE')
    },
    isAsterxUser() {
      const userOptions = this.currentUser?.options
      return userOptions != null && userOptions.includes('ASTERX')
    }
  },

  methods: {
    ...mapActions([
      'loadMissions',
      'resetResultsLog',
      'startATour',
      'start_gt_OrbitTransferParam1',
      'start_gt_OrbitTransferParam2',
      'start_gt_PerformanceAnalysis'
    ]),

    closeBetaDevelopments() {
      this.$emit('betaDevelopmentsClosed')
    },

    betaDevelopmentClicked(betaDevelopmentRoute) {
      this.$emit('betaDevelopmentsClosed')
      this.$router.push(betaDevelopmentRoute)
    },

    requestLogoutHandler() {
      this.logout()
    },

    openToolbox(toolboxName) {
      this.currentToolboxName = toolboxName
      this.toolboxDialog = !this.toolboxDialog
    },

    stopTheTour() {
      this.startATour(false)
      guidedTutorialParamOrbitalTransfer1.stopAllTours(this)
      guidedTutorialParamOrbitalTransfer2.stopAllTours(this)
      guidedTutorialPerformanceAnalysis.stopAllTours(this)
    },

    getFieldsBoundsStyle(range) {
      if (range === 'Range') {
        if (this.$vuetify.theme.dark === false) {
          return 'background-color: WhiteSmoke; font-weight: bold;'
        } else {
          return 'background-color: #656565; font-weight: bold;'
        }
      }
      return ''
    },

    downloadFile(endPoint, fileName, fileType) {
      Vue.axios.get(endPoint, { responseType: 'blob' }).then((response) => {
        if (response.data !== null) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: fileType })
          )
          const link = document.createElement('a')
          link.download = fileName
          link.href = url
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      })
    },

    downloadApiDoc() {
      this.downloadFile(
        '/users/documentationAPI/' + this.currentUser.id,
        'DocumentationAPI.zip',
        'application/zip'
      )
    },

    downloadApiReadme() {
      Vue.axios
        .get('/users/readmeAPI', { responseType: 'blob' })
        .then((response) => {
          if (response.data !== null) {
            response.data.text().then((value) => (this.readmeAPIraw = value))
          }
        })
    },

    openApiDialog() {
      this.apiDialog = !this.apiDialog
      if (this.apiDialog === true) {
        this.downloadApiReadme()
      }
    },

    getChangelog() {
      Vue.axios
        .get('/users/changelog', { responseType: 'blob' })
        .then((response) => {
          if (response.data !== null) {
            response.data.text().then((value) => (this.changelogRaw = value))
          }
        })
    },

    openChangelogDialog() {
      this.changelogDialog = !this.changelogDialog
      if (this.changelogDialog === true) {
        this.getChangelog()
      }
    },

    updateAnnounceMessage() {
      this.announceMessage = ''
      this.announceType = 'info'
      Vue.axios.get('/users/announce').then((response) => {
        if (response.data !== null) {
          let today = new Date()
          let todayYYYYMMDD = today.toISOString().split('T')[0]
          if (todayYYYYMMDD <= response.data.expirationDateYYYYMMDD) {
            this.announceMessage = response.data.message
            this.announceType = response.data.type
          }
        }
      })
    },

    updatePhysicalConstants() {
      Vue.axios
        .get('/physics/physicalconstants')
        .then((response) => {
          if (response.data !== null) {
            this.physicalConstants = response.data
          }
        })
        .catch((e) => {
          this.displayMessage(
            'Error getting space mechanic data',
            e,
            'notification',
            'error'
          )
        })
    },

    getInfos(item) {
      return dataTools.getInfos(item)
    },

    getSortedMissionList(missionList) {
      return missionList
        .sort((a, b) =>
          this.getUpdateDate(a) < this.getUpdateDate(b) ? 1 : -1
        )
        .slice(0, this.displayedMissionsLimit)
    },

    getUpdateDate(object) {
      if (object.updatedAt != null) {
        return object.updatedAt.valueOf()
      } else {
        return -1
      }
    },

    async logout() {
      delete localStorage.token
      delete localStorage.currentMissionId
      await this.$store.dispatch('logout')
      const referUrl = encodeURI(
        window.location.origin + window.location.pathname
      )
      const guardianUrl = process.env.GUARDIAN_URL
      const appName = process.env.APP_NAME
      window.location.href = `${guardianUrl}/#/?refer=${referUrl}&from=${appName}&goto=logout`
    },

    profile() {
      const referUrl = encodeURI(
        window.location.origin + window.location.pathname
      )
      const guardianUrl = process.env.GUARDIAN_URL
      const appName = process.env.APP_NAME
      window.location.href = `${guardianUrl}/#/?refer=${referUrl}&from=${appName}&goto=profile`
      // this.$router.push('/profile')
    },

    groups() {
      this.$router.push('/groups')
    },

    archives() {
      this.$router.push('/archives')
    },

    processes() {
      this.$router.push('/processes')
    },

    // TODO this methods are copied from mission, it should be in a tool file like data.js
    goToMission(mission) {
      this.sendMissionEventAfterRedirectionToDashboard(
        'set-current-mission',
        mission
      )
    },

    editMission(mission) {
      this.sendMissionEventAfterRedirectionToSettings(
        'set-current-mission',
        mission
      )
    },

    copyMission(mission) {
      this.sendMissionEventAfterRedirectionToSettings('copy-mission', mission)
    },

    resetCurrentMission() {
      // immediate effect
      this.$root.$emit('set-current-mission', null)
      localStorage.currentResultsId = null
      this.resetResultsLog(this.$root)
    },

    sendMissionEventAfterRedirectionToSettings(eventName, mission) {
      this.resetCurrentMission()
      this.redirectToMissionSetting(mission.typeName)
      // event send to root because it should be treated by sub components
      // use nextTick to be sure mission components are created and can handle events
      Vue.nextTick(() => {
        this.$root.$emit(eventName, mission)
      })
    },

    sendMissionEventAfterRedirectionToDashboard(eventName, mission) {
      this.resetCurrentMission()
      this.redirectToMissionDashboard(mission.typeName)
      // event send to root because it should be treated by sub components
      // use nextTick to be sure mission components are created and can handle events
      Vue.nextTick(() => {
        this.$root.$emit(eventName, mission)
      })
    },

    redirectToMissionSetting(typeName) {
      this.$router.push({
        path: '/' + missionTools.missionUrlMapping[typeName].settings
      })
    },

    redirectToMissionDashboard(typeName) {
      this.$router.push({
        path: '/' + missionTools.missionUrlMapping[typeName].dashboard
      })
    },

    removeIfNotUsedAsReference: function (item) {
      let self = this
      let objectName = item.name
      let objectId = item.id
      this.$http
        .delete(this.getItemAPI(item) + '/' + item.id)
        .then(() => {
          self.$root.$emit('delete-mission', objectId)
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting ' + objectName,
            e,
            'notification',
            'error'
          )
        })
    },

    getItemAPI(item) {
      return this.getAPI(item.typeName + 's')
    },

    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    }

    // ---------------------------------------------------------------------------------------------------------
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.menu-line:hover {
  background: rgba(0, 0, 0, 0.04);
}

.dark-toolbar {
  background: #303437 !important;
}

.dark-text {
  color: #343a40;
}

.edit-button:hover {
  color: #009688 !important;
}

.copy-button:hover {
  color: #2196f3 !important;
}

.delete-button:hover {
  color: #e91e63 !important;
}
</style>
